class Timer {
    constructor(seconds, callback) {
        this.seconds = seconds
        this.timer = null
        this.callback = callback
    }

    start() {
        this.stop()
        this.timer = setInterval(() => {
            this.callback()
        }, this.seconds * 1000)
    }

    stop() {
        clearInterval(this.timer)
    }
}
